import {Component, AfterViewInit, ViewChild} from '@angular/core';
import { ErrorService } from '../services/error.service';
import { Error } from '../models/error.model';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FileDialogComponent } from '../file-dialog/file-dialog.component';
import { Ng2FileUploadComponent } from '../ng2file/ng2file-upload.component';
import { CheckTokenService } from '../../common/services/check-token.service';
import { AuthorizationService } from '../../common/services/authorization.service';



@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css']
})
export class ImportComponent implements AfterViewInit {

  length = 100;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 100];


    isData = false;
    displayedColumns = ['name', 'date', 'row', 'error', 'status'];
    dataSource = new  MatTableDataSource<Error>();
    /*@ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;*/
    constructor(private authorizationService: AuthorizationService, private checkTokenService: CheckTokenService, private errorService: ErrorService, public dialog: MatDialog) {
      this.authorizationService.isClient();
    }
    
    ngAfterViewInit(): void {
        this.checkTokenService.verifyToken();

        this.errorService.getError().subscribe(
            data => {
                this.dataSource.data = data;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort
                this.isData = true;            });
    }
    
    
    private paginator: MatPaginator;
    private sort: MatSort;
  
    @ViewChild(MatSort) set matSort(ms: MatSort) {
      this.sort = ms;
      this.setDataSourceAttributes();
    }
  
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
      this.paginator = mp;
      this.setDataSourceAttributes();
    }
  
    setDataSourceAttributes() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
  
      /*if (this.paginator && this.sort) {
        this.applyFilter('');
      }*/
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    openDialog(): void {
    // let dialogRef =
      this.dialog.open(FileDialogComponent, {
      width: '550px', height: 'auto'
    });

}
}




// WEBPACK FOOTER //
// ./src/app/admin-app/import/import.component.ts